import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'
import cn from 'clsx'

import HighlightBorder from 'components/Common/HighlightBorder'

const StyledHighlightBorder = styled(HighlightBorder)`
  box-shadow: none;

  &.has-error {
    color: ${props => props.theme.palette.messaging.critical.main};
  }
`

type Props = React.ComponentProps<typeof components.Control>

function ReactSelectControl({ children, ...props }: Props) {
  const {
    isFocused,
    menuIsOpen,
    selectProps: { hasError },
  } = props

  return (
    <components.Control {...props}>
      <StyledHighlightBorder
        visible={isFocused || menuIsOpen || hasError}
        className={cn({ 'has-error': hasError, 'highlight-border': true })}
      />
      {children}
    </components.Control>
  )
}

export default ReactSelectControl
